var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldUnmapped = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.6.5c1.989 0 3.6.806 3.6 1.8 0 .995-1.611 1.8-3.6 1.8S0 3.295 0 2.3C0 1.306 1.611.5 3.6.5m1.542 4.327c-.444.363-.753.89-.841 1.489a7 7 0 0 1-.701.034c-1.989 0-3.6-.806-3.6-1.8V3.2C0 4.194 1.611 5 3.6 5c.552 0 1.075-.062 1.542-.173M6.42 4.32c.488-.307.779-.696.779-1.119v1.2a2.3 2.3 0 0 0-.78-.081zM4.332 7.213l.009.035c.075.297.213.565.485.987l.153.228A7 7 0 0 1 3.6 8.6C1.611 8.6 0 7.794 0 6.8V5.45c0 .994 1.611 1.8 3.6 1.8q.377 0 .732-.037m2.031 2.196C5.171 7.558 4.95 7.368 4.95 6.687 4.95 5.756 5.655 5 6.525 5S8.1 5.756 8.1 6.687c0 .68-.221.87-1.413 2.722a.19.19 0 0 1-.324 0m.162-2.018c.362 0 .656-.315.656-.704s-.294-.703-.656-.703-.656.315-.656.703c0 .389.294.704.656.704"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldUnmapped);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-unmapped.ac46b4c0.svg";